export default "__VITE_ASSET__BnbVBj6W__"